import React from "react";
import { useParams, Link } from "react-router-dom";
import { BLOG_POSTS } from "../constants/blogs";
import { img } from "../constants/copy";

export default function BlogPost() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);

  if (!post) {
    return (
      <section className="px-4 sm:px-6 md:px-10 lg:px-16 py-10 sm:py-14 md:py-20">
        <p className="text-white font-inter">Post not found.</p>
        <Link to="/blogs" className="btn-ghost mt-4 inline-block">
          ← Back to Blogs
        </Link>
      </section>
    );
  }

  const { title, excerpt, image, date } = post;

  return (
    <article className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-10 sm:py-14 md:py-20 lg:py-24">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/blogs"
          className="btn-ghost mb-6 sm:mb-8 inline-flex items-center gap-2"
        >
          ← Back to Blogs
        </Link>
        <time className="font-inter text-weddmac-gold/80 text-xs sm:text-sm tracking-wide">
          {date}
        </time>
        <h1 className="font-inria font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white mt-2 mb-4 sm:mb-6 tracking-tight">
          {title}
        </h1>
        <div className="aspect-video sm:aspect-[16/9] rounded-2xl overflow-hidden shadow-card mb-6 sm:mb-8">
          <img
            src={img(image)}
            alt={title}
            loading="lazy"
            className="w-full h-full object-cover"
          />
        </div>
        <p className="font-inter text-white/90 text-base sm:text-lg md:text-xl leading-relaxed">
          {excerpt}
        </p>
      </div>
    </article>
  );
}
